import React from "react";
import { I_KonkurBookletCategory, I_KonkurBookletPdf } from "../../../../Models/interfaces";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import Spinner from "../../../../Utils/ColoredSpinner/Spinner";
import PdfItem from "./PdfItem";

interface CategoryItemProps {
  category: I_KonkurBookletCategory;
  isExpanded: boolean;
  onToggle: (categoryId: number) => void;
  pdfs: I_KonkurBookletPdf[];
  loading: boolean;
  onDownload: (pdf: I_KonkurBookletPdf) => void;
  onPurchase: (pdf: I_KonkurBookletPdf) => void;
}

const CategoryItem: React.FC<CategoryItemProps> = ({
  category,
  isExpanded,
  onToggle,
  pdfs,
  loading,
  onDownload,
  onPurchase,
}) => {
  return (
    <div className="border border-gray-100 rounded-md">
      <div
        className="flex items-center justify-between p-2 cursor-pointer hover:bg-gray-50 transition"
        onClick={() => onToggle(category.id)}
      >
        <span className="text-gray-700">{category.title}</span>
        <span className="text-gray-400">
          {isExpanded ? <AiOutlineDown /> : <AiOutlineRight />}
        </span>
      </div>

      {isExpanded && (
        <div className="border-t border-gray-100 p-2 pr-6 space-y-1">
          {loading ? (
            <div className="flex justify-center py-2">
              <Spinner />
            </div>
          ) : pdfs.length === 0 ? (
            <p className="text-sm text-gray-400">دفترچه‌ای موجود نیست.</p>
          ) : (
            pdfs.map((pdf) => (
              <PdfItem
                key={pdf.id}
                pdf={pdf}
                onDownload={onDownload}
                onPurchase={onPurchase}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryItem;